import { block as blockNS } from '../../cls';
import './table.less';

export var block = blockNS('table');
export var image = block('image');
export var table = block('table')();
export var column = block('column');
export var cell = block('cell');
export var emptyCell = block('emptyCell')();
export var wrapper = cell('wrapper');
export var separator = block('separator')();